var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg360FileSyncLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 458.8 559.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M158.16,165.25l100.38,129.21c152.35-172.99,183.93-220.31,183.93-220.31-152.35,133.84-183.66,155.71-183.66,155.71-66.92-46.99-100.65-64.6-100.65-64.6h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M318.81,330.12c7.14-.48,14.28-1.05,21.41-1.72,17.09-1.61,34.56-3.77,51.33-7.5.74-.16,1.49-.33,2.24-.51v-169.31c-11.66,14.12-23.44,28.13-35.28,42.09-30.64,36.12-61.73,71.86-93.03,107.4-1.88,2.14-4.37,3.22-7.22,3.13-2.85-.09-5.27-1.32-7.01-3.57l-100.38-129.21c-2.7-3.47-2.61-8.22.21-11.59,2.82-3.37,7.48-4.3,11.37-2.26,8.76,4.58,17.51,9.92,25.93,15.07,23.89,14.62,47.28,30.29,70.27,46.32l2.1-1.63c9.18-7.15,18.21-14.55,27.18-21.96,35.7-29.51,70.91-59.83,105.87-90.34v-24.65c0-4.69-1.69-8.73-5.04-12.01L324.48,4.82c-3.27-3.21-7.21-4.82-11.78-4.82h-184.21c-9.27,0-16.83,7.56-16.83,16.83v205.52s-2.35-63.68-5.56-191.24l-36.59,5.23c-4.45,1.22-10.12,1.42-6.06,11.92,25.98,67.13,43.72,134.33,47.3,208.67.33,4.48.64,9,.91,13.56v50.51c0-93.21-12.02-171.59-50.25-260.56l-30.83,6.89c-9.82,2.6-13.22,1.6-5.05,13.51,46.35,67.56,75.99,146.97,86.14,240.16,0,3.73,1.22,7.18,3.29,9.97,34.51,9.93,64.42,6.86,100.12,6.86l6.34-.06h6.62c-1.78-4.47,3.78,3.8.21.51l-.21-.5h0c13.3-2.76-.53.72,25.36-2.14,17.54-.73,35.38-4.42,56.29-4.88l9.14-.62Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-228",
    style: {
      clipPath: "url(#clippath)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    style: {
      fill: "#58984a"
    },
    x: 59.59,
    y: 392.73,
    width: 463.71,
    height: 0.75,
    transform: "translate(-95.75 93.85) rotate(-15.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#589949"
    },
    className: "cls-20",
    x: 59.57,
    y: 391.8,
    width: 463.71,
    height: 2.54,
    transform: "translate(-95.61 93.67) rotate(-15.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#599949"
    },
    className: "cls-75",
    x: 59.11,
    y: 390.17,
    width: 463.71,
    height: 2.54,
    transform: "translate(-95.27 93.6) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5b9949"
    },
    className: "cls-119",
    x: 58.66,
    y: 388.55,
    width: 463.71,
    height: 2.54,
    transform: "translate(-94.82 93.38) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5a9a49"
    },
    className: "cls-223",
    x: 58.2,
    y: 386.92,
    width: 463.71,
    height: 2.54,
    transform: "translate(-94.42 93.23) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c9a49"
    },
    className: "cls-241",
    x: 57.74,
    y: 385.29,
    width: 463.71,
    height: 2.54,
    transform: "translate(-93.97 93.01) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5d9a49"
    },
    className: "cls-189",
    x: 57.28,
    y: 383.67,
    width: 463.71,
    height: 2.54,
    transform: "translate(-93.49 92.75) rotate(-15.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5c9b49"
    },
    className: "cls-177",
    x: 56.82,
    y: 382.04,
    width: 463.71,
    height: 2.53,
    transform: "translate(-93.14 92.67) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5d9b49"
    },
    className: "cls-124",
    x: 56.36,
    y: 380.41,
    width: 463.71,
    height: 2.53,
    transform: "translate(-92.72 92.48) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5e9b4a"
    },
    className: "cls-139",
    x: 55.91,
    y: 378.79,
    width: 463.71,
    height: 2.54,
    transform: "translate(-92.3 92.31) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5f9b49"
    },
    className: "cls-128",
    x: 55.45,
    y: 377.16,
    width: 463.71,
    height: 2.54,
    transform: "translate(-91.88 92.12) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5f9d4a"
    },
    className: "cls-229",
    x: 54.99,
    y: 375.53,
    width: 463.71,
    height: 2.54,
    transform: "translate(-91.42 91.89) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#609c49"
    },
    className: "cls-212",
    x: 54.53,
    y: 373.91,
    width: 463.71,
    height: 2.54,
    transform: "translate(-90.96 91.66) rotate(-15.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#619c49"
    },
    className: "cls-167",
    x: 54.07,
    y: 372.28,
    width: 463.71,
    height: 2.54,
    transform: "translate(-90.57 91.52) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#619d4a"
    },
    className: "cls-30",
    x: 53.61,
    y: 370.65,
    width: 463.71,
    height: 2.54,
    transform: "translate(-90.18 91.38) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#629d4a"
    },
    className: "cls-130",
    x: 53.16,
    y: 369.03,
    width: 463.71,
    height: 2.54,
    transform: "translate(-89.76 91.19) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#629d4a"
    },
    className: "cls-130",
    x: 52.7,
    y: 367.4,
    width: 463.71,
    height: 2.54,
    transform: "translate(-89.3 90.97) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#639e49"
    },
    className: "cls-142",
    x: 52.24,
    y: 365.77,
    width: 463.71,
    height: 2.53,
    transform: "translate(-88.83 90.72) rotate(-15.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#639e49"
    },
    className: "cls-142",
    x: 51.78,
    y: 364.15,
    width: 463.71,
    height: 2.53,
    transform: "translate(-88.48 90.63) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#659e49"
    },
    className: "cls-28",
    x: 51.32,
    y: 362.52,
    width: 463.71,
    height: 2.54,
    transform: "translate(-88.03 90.41) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#669f4a"
    },
    className: "cls-13",
    x: 50.87,
    y: 360.89,
    width: 463.71,
    height: 2.54,
    transform: "translate(-87.63 90.26) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#679f48"
    },
    className: "cls-181",
    x: 50.41,
    y: 359.26,
    width: 463.71,
    height: 2.54,
    transform: "translate(-87.18 90.04) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#679f48"
    },
    className: "cls-181",
    x: 49.95,
    y: 357.64,
    width: 463.71,
    height: 2.54,
    transform: "translate(-86.79 89.9) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#68a048"
    },
    className: "cls-232",
    x: 49.49,
    y: 356.01,
    width: 463.71,
    height: 2.54,
    transform: "translate(-86.29 89.6) rotate(-15.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#69a048"
    },
    className: "cls-194",
    x: 49.03,
    y: 354.38,
    width: 463.71,
    height: 2.54,
    transform: "translate(-85.92 89.5) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#69a048"
    },
    className: "cls-194",
    x: 48.57,
    y: 352.76,
    width: 463.71,
    height: 2.54,
    transform: "translate(-85.52 89.34) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#6aa048"
    },
    className: "cls-244",
    x: 48.12,
    y: 351.13,
    width: 463.71,
    height: 2.53,
    transform: "translate(-85.06 89.11) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#6ba148"
    },
    className: "cls-234",
    x: 47.66,
    y: 349.5,
    width: 463.71,
    height: 2.53,
    transform: "translate(-84.67 88.97) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#6ca148"
    },
    className: "cls-226",
    x: 47.2,
    y: 347.88,
    width: 463.71,
    height: 2.53,
    transform: "translate(-84.19 88.7) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#6ca148"
    },
    className: "cls-226",
    x: 46.74,
    y: 346.25,
    width: 463.71,
    height: 2.54,
    transform: "translate(-83.79 88.55) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#6da247"
    },
    className: "cls-19",
    x: 46.28,
    y: 344.62,
    width: 463.71,
    height: 2.54,
    transform: "translate(-83.4 88.42) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#6ea247"
    },
    className: "cls-242",
    x: 45.82,
    y: 343,
    width: 463.71,
    height: 2.54,
    transform: "translate(-82.95 88.19) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#6fa247"
    },
    className: "cls-24",
    x: 45.37,
    y: 341.37,
    width: 463.71,
    height: 2.54,
    transform: "translate(-82.54 88.04) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#70a348"
    },
    className: "cls-211",
    x: 44.91,
    y: 339.74,
    width: 463.71,
    height: 2.54,
    transform: "translate(-82.12 87.85) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#71a447"
    },
    className: "cls-104",
    x: 44.45,
    y: 338.12,
    width: 463.71,
    height: 2.54,
    transform: "translate(-81.6 87.54) rotate(-15.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#72a347"
    },
    className: "cls-230",
    x: 43.99,
    y: 336.49,
    width: 463.71,
    height: 2.54,
    transform: "translate(-81.27 87.48) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#72a447"
    },
    className: "cls-78",
    x: 43.53,
    y: 334.86,
    width: 463.71,
    height: 2.53,
    transform: "translate(-80.83 87.27) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#72a447"
    },
    className: "cls-78",
    x: 43.07,
    y: 333.24,
    width: 463.71,
    height: 2.53,
    transform: "translate(-80.43 87.11) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#73a447"
    },
    className: "cls-151",
    x: 42.62,
    y: 331.61,
    width: 463.71,
    height: 2.53,
    transform: "translate(-80.02 86.96) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#74a547"
    },
    className: "cls-165",
    x: 42.16,
    y: 329.98,
    width: 463.71,
    height: 2.54,
    transform: "translate(-79.49 86.61) rotate(-15.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#74a546"
    },
    className: "cls-147",
    x: 41.7,
    y: 328.36,
    width: 463.71,
    height: 2.54,
    transform: "translate(-79.16 86.56) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#75a546"
    },
    className: "cls-37",
    x: 41.24,
    y: 326.73,
    width: 463.71,
    height: 2.54,
    transform: "translate(-78.72 86.36) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#76a646"
    },
    className: "cls-238",
    x: 40.78,
    y: 325.1,
    width: 463.71,
    height: 2.54,
    transform: "translate(-78.28 86.15) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#77a546"
    },
    className: "cls-202",
    x: 40.33,
    y: 323.48,
    width: 463.71,
    height: 2.54,
    transform: "translate(-77.88 86.01) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#77a546"
    },
    className: "cls-202",
    x: 39.87,
    y: 321.85,
    width: 463.71,
    height: 2.54,
    transform: "translate(-77.43 85.78) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#79a645"
    },
    className: "cls-66",
    x: 39.41,
    y: 320.22,
    width: 463.71,
    height: 2.54,
    transform: "translate(-76.97 85.54) rotate(-15.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#79a746"
    },
    className: "cls-192",
    x: 38.95,
    y: 318.6,
    width: 463.71,
    height: 2.53,
    transform: "translate(-76.61 85.44) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#79a746"
    },
    className: "cls-192",
    x: 38.49,
    y: 316.97,
    width: 463.71,
    height: 2.53,
    transform: "translate(-76.18 85.25) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#7aa746"
    },
    className: "cls-222",
    x: 38.03,
    y: 315.34,
    width: 463.71,
    height: 2.53,
    transform: "translate(-75.78 85.11) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#7ba846"
    },
    className: "cls-93",
    x: 37.58,
    y: 313.72,
    width: 463.71,
    height: 2.54,
    transform: "translate(-75.31 84.86) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#7ca846"
    },
    className: "cls-118",
    x: 37.12,
    y: 312.09,
    width: 463.71,
    height: 2.54,
    transform: "translate(-74.85 84.62) rotate(-15.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#7ca846"
    },
    className: "cls-118",
    x: 36.66,
    y: 310.46,
    width: 463.71,
    height: 2.53,
    transform: "translate(-74.43 84.43) rotate(-15.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#7da946"
    },
    className: "cls-149",
    x: 36.2,
    y: 308.84,
    width: 463.71,
    height: 2.54,
    transform: "translate(-74.05 84.31) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#7ea946"
    },
    className: "cls-61",
    x: 35.74,
    y: 307.21,
    width: 463.71,
    height: 2.54,
    transform: "translate(-73.64 84.15) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#80a947"
    },
    className: "cls-2",
    x: 35.28,
    y: 305.58,
    width: 463.71,
    height: 2.54,
    transform: "translate(-73.19 83.92) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#7faa47"
    },
    className: "cls-217",
    x: 34.83,
    y: 303.96,
    width: 463.71,
    height: 2.54,
    transform: "translate(-72.78 83.75) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#80aa47"
    },
    className: "cls-225",
    x: 34.37,
    y: 302.33,
    width: 463.71,
    height: 2.53,
    transform: "translate(-72.31 83.5) rotate(-15.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#81aa47"
    },
    className: "cls-94",
    x: 33.91,
    y: 300.7,
    width: 463.71,
    height: 2.53,
    transform: "translate(-71.94 83.4) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#81ab47"
    },
    className: "cls-203",
    x: 33.45,
    y: 299.08,
    width: 463.71,
    height: 2.53,
    transform: "translate(-71.54 83.25) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#82ab47"
    },
    className: "cls-206",
    x: 32.99,
    y: 297.45,
    width: 463.71,
    height: 2.54,
    transform: "translate(-71.09 83.03) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#84ab46"
    },
    className: "cls-46",
    x: 32.53,
    y: 295.82,
    width: 463.71,
    height: 2.54,
    transform: "translate(-70.65 82.82) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#85ab46"
    },
    className: "cls-182",
    x: 32.08,
    y: 294.2,
    width: 463.71,
    height: 2.53,
    transform: "translate(-70.2 82.59) rotate(-15.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#85ac46"
    },
    className: "cls-49",
    x: 31.62,
    y: 292.57,
    width: 463.71,
    height: 2.54,
    transform: "translate(-69.75 82.36) rotate(-15.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#86ac47"
    },
    className: "cls-4",
    x: 31.16,
    y: 290.94,
    width: 463.71,
    height: 2.54,
    transform: "translate(-69.4 82.3) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#86ac47"
    },
    className: "cls-4",
    x: 30.7,
    y: 289.32,
    width: 463.71,
    height: 2.54,
    transform: "translate(-68.97 82.11) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#86ad47"
    },
    className: "cls-126",
    x: 30.24,
    y: 287.69,
    width: 463.71,
    height: 2.54,
    transform: "translate(-68.54 81.9) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#87ad47"
    },
    className: "cls-123",
    x: 29.79,
    y: 286.06,
    width: 463.71,
    height: 2.53,
    transform: "translate(-68.13 81.74) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#88ad46"
    },
    className: "cls-25",
    x: 29.33,
    y: 284.44,
    width: 463.71,
    height: 2.53,
    transform: "translate(-67.66 81.48) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#89ae46"
    },
    className: "cls-71",
    x: 28.87,
    y: 282.81,
    width: 463.71,
    height: 2.54,
    transform: "translate(-67.26 81.34) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#89ae46"
    },
    className: "cls-71",
    x: 28.41,
    y: 281.18,
    width: 463.71,
    height: 2.54,
    transform: "translate(-66.85 81.17) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#8aae46"
    },
    className: "cls-67",
    x: 27.95,
    y: 279.55,
    width: 463.71,
    height: 2.54,
    transform: "translate(-66.42 80.98) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#8cb046"
    },
    className: "cls-221",
    x: 27.49,
    y: 277.93,
    width: 463.71,
    height: 2.54,
    transform: "translate(-66.01 80.82) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#8daf46"
    },
    className: "cls-198",
    x: 27.04,
    y: 276.3,
    width: 463.71,
    height: 2.54,
    transform: "translate(-65.53 80.54) rotate(-15.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#8daf46"
    },
    className: "cls-198",
    x: 26.58,
    y: 274.67,
    width: 463.71,
    height: 2.54,
    transform: "translate(-65.11 80.36) rotate(-15.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#8eb046"
    },
    className: "cls-22",
    x: 26.12,
    y: 273.05,
    width: 463.71,
    height: 2.54,
    transform: "translate(-64.73 80.25) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#8eb045"
    },
    className: "cls-218",
    x: 25.66,
    y: 271.42,
    width: 463.71,
    height: 2.54,
    transform: "translate(-64.29 80.04) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#8eb045"
    },
    className: "cls-218",
    x: 25.2,
    y: 269.79,
    width: 463.71,
    height: 2.53,
    transform: "translate(-63.89 79.89) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#8fb045"
    },
    className: "cls-178",
    x: 24.74,
    y: 268.17,
    width: 463.71,
    height: 2.53,
    transform: "translate(-63.48 79.72) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#90b145"
    },
    className: "cls-42",
    x: 24.29,
    y: 266.54,
    width: 463.71,
    height: 2.54,
    transform: "translate(-62.97 79.41) rotate(-15.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#91b145"
    },
    className: "cls-59",
    x: 23.83,
    y: 264.91,
    width: 463.71,
    height: 2.54,
    transform: "translate(-62.62 79.34) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#91b144"
    },
    className: "cls-11",
    x: 23.37,
    y: 263.29,
    width: 463.71,
    height: 2.54,
    transform: "translate(-62.17 79.12) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#93b243"
    },
    className: "cls-131",
    x: 22.91,
    y: 261.66,
    width: 463.71,
    height: 2.54,
    transform: "translate(-61.77 78.96) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#94b243"
    },
    className: "cls-76",
    x: 22.45,
    y: 260.03,
    width: 463.71,
    height: 2.54,
    transform: "translate(-61.34 78.77) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#95b244"
    },
    className: "cls-145",
    x: 21.99,
    y: 258.41,
    width: 463.71,
    height: 2.54,
    transform: "translate(-60.86 78.48) rotate(-15.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#95b344"
    },
    className: "cls-1",
    x: 21.54,
    y: 256.78,
    width: 463.71,
    height: 2.53,
    transform: "translate(-60.45 78.33) rotate(-15.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#96b344"
    },
    className: "cls-150",
    x: 21.08,
    y: 255.15,
    width: 463.71,
    height: 2.53,
    transform: "translate(-60.07 78.22) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#97b343"
    },
    className: "cls-31",
    x: 20.62,
    y: 253.53,
    width: 463.71,
    height: 2.53,
    transform: "translate(-59.63 78.01) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#97b443"
    },
    className: "cls-80",
    x: 20.16,
    y: 251.9,
    width: 463.71,
    height: 2.53,
    transform: "translate(-59.23 77.87) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#98b444"
    },
    className: "cls-40",
    x: 19.7,
    y: 250.27,
    width: 463.71,
    height: 2.54,
    transform: "translate(-58.78 77.64) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#98b444"
    },
    className: "cls-40",
    x: 19.24,
    y: 248.65,
    width: 463.71,
    height: 2.53,
    transform: "translate(-58.33 77.4) rotate(-15.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#9ab543"
    },
    className: "cls-90",
    x: 18.79,
    y: 247.02,
    width: 463.71,
    height: 2.54,
    transform: "translate(-57.94 77.28) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#9ab543"
    },
    className: "cls-90",
    x: 18.33,
    y: 245.39,
    width: 463.71,
    height: 2.54,
    transform: "translate(-57.51 77.08) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#9bb544"
    },
    className: "cls-148",
    x: 17.87,
    y: 243.77,
    width: 463.71,
    height: 2.54,
    transform: "translate(-57.1 76.92) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#9db744"
    },
    className: "cls-208",
    x: 17.41,
    y: 242.14,
    width: 463.71,
    height: 2.54,
    transform: "translate(-56.67 76.72) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#9eb745"
    },
    className: "cls-168",
    x: 16.95,
    y: 240.51,
    width: 463.71,
    height: 2.54,
    transform: "translate(-56.21 76.47) rotate(-15.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#9eb745"
    },
    className: "cls-168",
    x: 16.5,
    y: 238.89,
    width: 463.71,
    height: 2.53,
    transform: "translate(-55.78 76.28) rotate(-15.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#9fb745"
    },
    className: "cls-144",
    x: 16.04,
    y: 237.26,
    width: 463.71,
    height: 2.53,
    transform: "translate(-55.4 76.18) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#a0b845"
    },
    className: "cls-101",
    x: 15.58,
    y: 235.63,
    width: 463.71,
    height: 2.53,
    transform: "translate(-54.99 76.01) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#a0b845"
    },
    className: "cls-101",
    x: 15.12,
    y: 234.01,
    width: 463.71,
    height: 2.54,
    transform: "translate(-54.55 75.79) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#a1b845"
    },
    className: "cls-114",
    x: 14.66,
    y: 232.38,
    width: 463.71,
    height: 2.54,
    transform: "translate(-54.14 75.63) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#a1b946"
    },
    className: "cls-159",
    x: 14.2,
    y: 230.75,
    width: 463.71,
    height: 2.54,
    transform: "translate(-53.66 75.36) rotate(-15.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#a2b945"
    },
    className: "cls-48",
    x: 13.75,
    y: 229.13,
    width: 463.71,
    height: 2.54,
    transform: "translate(-53.27 75.23) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#a2b945"
    },
    className: "cls-48",
    x: 13.29,
    y: 227.5,
    width: 463.71,
    height: 2.54,
    transform: "translate(-52.86 75.06) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#a3ba46"
    },
    className: "cls-204",
    x: 12.83,
    y: 225.87,
    width: 463.71,
    height: 2.54,
    transform: "translate(-52.44 74.88) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#a4ba47"
    },
    className: "cls-195",
    x: 12.37,
    y: 224.25,
    width: 463.71,
    height: 2.54,
    transform: "translate(-52 74.68) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#a5ba46"
    },
    className: "cls-92",
    x: 11.91,
    y: 222.62,
    width: 463.71,
    height: 2.53,
    transform: "translate(-51.55 74.43) rotate(-15.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#a5bb47"
    },
    className: "cls-140",
    x: 11.45,
    y: 220.99,
    width: 463.71,
    height: 2.53,
    transform: "translate(-51.13 74.25) rotate(-15.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#a6bb46"
    },
    className: "cls-239",
    x: 11,
    y: 219.37,
    width: 463.71,
    height: 2.53,
    transform: "translate(-50.75 74.16) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#a7bb47"
    },
    className: "cls-106",
    x: 10.54,
    y: 217.74,
    width: 463.71,
    height: 2.54,
    transform: "translate(-50.32 73.96) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#a7bc47"
    },
    className: "cls-193",
    x: 10.08,
    y: 216.11,
    width: 463.71,
    height: 2.54,
    transform: "translate(-49.88 73.75) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#a8bc47"
    },
    className: "cls-55",
    x: 9.62,
    y: 214.49,
    width: 463.71,
    height: 2.54,
    transform: "translate(-49.47 73.58) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#a9bc46"
    },
    className: "cls-132",
    x: 9.16,
    y: 212.86,
    width: 463.71,
    height: 2.54,
    transform: "translate(-49 73.3) rotate(-15.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#aabc47"
    },
    className: "cls-88",
    x: 8.7,
    y: 211.23,
    width: 463.71,
    height: 2.54,
    transform: "translate(-48.61 73.19) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#aabd46"
    },
    className: "cls-77",
    x: 8.25,
    y: 209.6,
    width: 463.71,
    height: 2.54,
    transform: "translate(-48.2 73.03) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#abbd47"
    },
    className: "cls-83",
    x: 7.79,
    y: 207.98,
    width: 463.71,
    height: 2.54,
    transform: "translate(-47.76 72.83) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#acbd47"
    },
    className: "cls-199",
    x: 7.33,
    y: 206.35,
    width: 463.71,
    height: 2.53,
    transform: "translate(-47.34 72.65) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#acbe46"
    },
    className: "cls-190",
    x: 6.87,
    y: 204.73,
    width: 463.71,
    height: 2.53,
    transform: "translate(-46.9 72.42) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#adbe46"
    },
    className: "cls-155",
    x: 6.41,
    y: 203.1,
    width: 463.71,
    height: 2.53,
    transform: "translate(-46.47 72.23) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#aebe46"
    },
    className: "cls-141",
    x: 5.95,
    y: 201.47,
    width: 463.71,
    height: 2.54,
    transform: "translate(-46.07 72.1) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#afbf44"
    },
    className: "cls-110",
    x: 5.5,
    y: 199.84,
    width: 463.71,
    height: 2.54,
    transform: "translate(-45.64 71.9) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#afbf44"
    },
    className: "cls-110",
    x: 5.04,
    y: 198.22,
    width: 463.71,
    height: 2.54,
    transform: "translate(-45.23 71.73) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#b0be43"
    },
    className: "cls-152",
    x: 4.58,
    y: 196.59,
    width: 463.71,
    height: 2.54,
    transform: "translate(-44.79 71.52) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#b1bf43"
    },
    className: "cls-233",
    x: 4.12,
    y: 194.96,
    width: 463.71,
    height: 2.53,
    transform: "translate(-44.34 71.27) rotate(-15.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#b2c043"
    },
    className: "cls-243",
    x: 3.66,
    y: 193.34,
    width: 463.71,
    height: 2.54,
    transform: "translate(-43.95 71.18) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#b2c043"
    },
    className: "cls-243",
    x: 3.21,
    y: 191.71,
    width: 463.71,
    height: 2.54,
    transform: "translate(-43.52 70.97) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#b3c043"
    },
    className: "cls-60",
    x: 2.75,
    y: 190.08,
    width: 463.71,
    height: 2.53,
    transform: "translate(-43.11 70.81) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#b3c043"
    },
    className: "cls-60",
    x: 2.29,
    y: 188.46,
    width: 463.71,
    height: 2.53,
    transform: "translate(-42.69 70.64) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#b3c043"
    },
    className: "cls-60",
    x: 1.83,
    y: 186.83,
    width: 463.71,
    height: 2.54,
    transform: "translate(-42.25 70.42) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#b4c042"
    },
    className: "cls-201",
    x: 1.37,
    y: 185.2,
    width: 463.71,
    height: 2.54,
    transform: "translate(-41.8 70.17) rotate(-15.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#b5c142"
    },
    className: "cls-133",
    x: 0.91,
    y: 183.58,
    width: 463.71,
    height: 2.54,
    transform: "translate(-41.4 70.05) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#b6c143"
    },
    className: "cls-108",
    x: 0.46,
    y: 181.95,
    width: 463.71,
    height: 2.54,
    transform: "translate(-40.97 69.85) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#b6c143"
    },
    className: "cls-108",
    x: 0,
    y: 180.32,
    width: 463.71,
    height: 2.54,
    transform: "translate(-40.56 69.69) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#b7c243"
    },
    className: "cls-120",
    x: -0.46,
    y: 178.7,
    width: 463.71,
    height: 2.54,
    transform: "translate(-40.13 69.49) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#b8c243"
    },
    className: "cls-65",
    x: -0.92,
    y: 177.07,
    width: 463.71,
    height: 2.54,
    transform: "translate(-39.68 69.25) rotate(-15.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#bac243"
    },
    className: "cls-196",
    x: -1.38,
    y: 175.44,
    width: 463.71,
    height: 2.54,
    transform: "translate(-39.29 69.14) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#b9c343"
    },
    className: "cls-107",
    x: -1.84,
    y: 173.82,
    width: 463.71,
    height: 2.53,
    transform: "translate(-38.86 68.93) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#bbc343"
    },
    className: "cls-89",
    x: -2.29,
    y: 172.19,
    width: 463.71,
    height: 2.53,
    transform: "translate(-38.45 68.79) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#bbc343"
    },
    className: "cls-89",
    x: -2.75,
    y: 170.56,
    width: 463.71,
    height: 2.54,
    transform: "translate(-38.01 68.56) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#bcc442"
    },
    className: "cls-215",
    x: -3.21,
    y: 168.94,
    width: 463.71,
    height: 2.54,
    transform: "translate(-37.59 68.4) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#bcc442"
    },
    className: "cls-215",
    x: -3.67,
    y: 167.31,
    width: 463.71,
    height: 2.54,
    transform: "translate(-37.14 68.15) rotate(-15.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#bdc442"
    },
    className: "cls-8",
    x: -4.13,
    y: 165.68,
    width: 463.71,
    height: 2.54,
    transform: "translate(-36.74 68) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#bec542"
    },
    className: "cls-38",
    x: -4.59,
    y: 164.06,
    width: 463.71,
    height: 2.54,
    transform: "translate(-36.32 67.84) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#bec542"
    },
    className: "cls-38",
    x: -5.04,
    y: 162.43,
    width: 463.71,
    height: 2.54,
    transform: "translate(-35.89 67.64) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#bfc543"
    },
    className: "cls-69",
    x: -5.5,
    y: 160.8,
    width: 463.71,
    height: 2.54,
    transform: "translate(-35.47 67.46) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#c0c542"
    },
    className: "cls-235",
    x: -5.96,
    y: 159.18,
    width: 463.71,
    height: 2.53,
    transform: "translate(-35.03 67.22) rotate(-15.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#c1c642"
    },
    className: "cls-18",
    x: -6.42,
    y: 157.55,
    width: 463.71,
    height: 2.53,
    transform: "translate(-34.62 67.08) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#c1c642"
    },
    className: "cls-18",
    x: -6.88,
    y: 155.92,
    width: 463.71,
    height: 2.53,
    transform: "translate(-34.21 66.93) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#c3c642"
    },
    className: "cls-47",
    x: -7.34,
    y: 154.3,
    width: 463.71,
    height: 2.54,
    transform: "translate(-33.77 66.72) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#c4c742"
    },
    className: "cls-163",
    x: -7.79,
    y: 152.67,
    width: 463.71,
    height: 2.54,
    transform: "translate(-33.35 66.52) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#c4c742"
    },
    className: "cls-163",
    x: -8.25,
    y: 151.04,
    width: 463.71,
    height: 2.54,
    transform: "translate(-32.93 66.36) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#c4c742"
    },
    className: "cls-163",
    x: -8.71,
    y: 149.42,
    width: 463.71,
    height: 2.53,
    transform: "translate(-32.48 66.09) rotate(-15.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#c5c843"
    },
    className: "cls-135",
    x: -9.17,
    y: 147.79,
    width: 463.71,
    height: 2.54,
    transform: "translate(-32.08 65.99) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#c6c842"
    },
    className: "cls-173",
    x: -9.63,
    y: 146.16,
    width: 463.71,
    height: 2.54,
    transform: "translate(-31.66 65.8) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#c6c842"
    },
    className: "cls-173",
    x: -10.08,
    y: 144.54,
    width: 463.71,
    height: 2.54,
    transform: "translate(-31.22 65.59) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#c7c942"
    },
    className: "cls-227",
    x: -10.54,
    y: 142.91,
    width: 463.71,
    height: 2.53,
    transform: "translate(-30.81 65.44) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#c8c942"
    },
    className: "cls-3",
    x: -11,
    y: 141.28,
    width: 463.71,
    height: 2.53,
    transform: "translate(-30.36 65.16) rotate(-15.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#c9c943"
    },
    className: "cls-179",
    x: -11.46,
    y: 139.66,
    width: 463.71,
    height: 2.53,
    transform: "translate(-29.97 65.08) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#c9ca43"
    },
    className: "cls-200",
    x: -11.92,
    y: 138.03,
    width: 463.71,
    height: 2.54,
    transform: "translate(-29.54 64.88) rotate(-15.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#cac941"
    },
    className: "cls-97",
    x: -12.38,
    y: 136.4,
    width: 463.71,
    height: 2.54,
    transform: "translate(-29.11 64.67) rotate(-15.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#cbca42"
    },
    className: "cls-81",
    x: -12.53,
    y: 137.01,
    width: 463.71,
    height: 0.26,
    transform: "translate(-29.06 64.94) rotate(-15.81)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-113",
    style: {
      clipPath: "url(#clippath-1)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#1f509e"
    },
    className: "cls-172",
    x: 111.03,
    y: 351.58,
    width: 358.46,
    height: 0.16,
    transform: "translate(-89.51 99.29) rotate(-16.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#21509e"
    },
    className: "cls-197",
    x: 110.93,
    y: 350.52,
    width: 358.46,
    height: 1.62,
    transform: "translate(-89.49 99.35) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#1f519f"
    },
    className: "cls-138",
    x: 110.62,
    y: 349.49,
    width: 358.46,
    height: 1.62,
    transform: "translate(-89.07 99.02) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#1f51a0"
    },
    className: "cls-183",
    x: 110.31,
    y: 348.46,
    width: 358.46,
    height: 1.62,
    transform: "translate(-88.74 98.81) rotate(-16.83)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#1f51a0"
    },
    className: "cls-183",
    x: 109.99,
    y: 347.42,
    width: 358.46,
    height: 1.62,
    transform: "translate(-88.47 98.7) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#1f52a0"
    },
    className: "cls-5",
    x: 109.68,
    y: 346.39,
    width: 358.46,
    height: 1.62,
    transform: "translate(-88.22 98.62) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2152a1"
    },
    className: "cls-44",
    x: 109.37,
    y: 345.36,
    width: 358.46,
    height: 1.62,
    transform: "translate(-87.94 98.5) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#1f52a1"
    },
    className: "cls-240",
    x: 109.06,
    y: 344.33,
    width: 358.46,
    height: 1.62,
    transform: "translate(-87.75 98.51) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#1f53a2"
    },
    className: "cls-111",
    x: 108.74,
    y: 343.3,
    width: 358.46,
    height: 1.62,
    transform: "translate(-87.47 98.39) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#1f53a2"
    },
    className: "cls-111",
    x: 108.43,
    y: 342.27,
    width: 358.46,
    height: 1.62,
    transform: "translate(-87.06 98.06) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#1f53a2"
    },
    className: "cls-111",
    x: 108.12,
    y: 341.23,
    width: 358.46,
    height: 1.62,
    transform: "translate(-86.75 97.88) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2053a2"
    },
    className: "cls-12",
    x: 107.81,
    y: 340.2,
    width: 358.46,
    height: 1.62,
    transform: "translate(-86.46 97.74) rotate(-16.83)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2053a2"
    },
    className: "cls-12",
    x: 107.49,
    y: 339.17,
    width: 358.46,
    height: 1.62,
    transform: "translate(-86.21 97.66) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2154a4"
    },
    className: "cls-127",
    x: 107.18,
    y: 338.14,
    width: 358.46,
    height: 1.62,
    transform: "translate(-85.95 97.57) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2154a4"
    },
    className: "cls-127",
    x: 106.87,
    y: 337.11,
    width: 358.46,
    height: 1.62,
    transform: "translate(-85.75 97.56) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2154a3"
    },
    className: "cls-52",
    x: 106.56,
    y: 336.07,
    width: 358.46,
    height: 1.62,
    transform: "translate(-85.47 97.44) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2255a4"
    },
    className: "cls-153",
    x: 106.24,
    y: 335.04,
    width: 358.46,
    height: 1.62,
    transform: "translate(-85.07 97.13) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2255a4"
    },
    className: "cls-153",
    x: 105.93,
    y: 334.01,
    width: 358.46,
    height: 1.62,
    transform: "translate(-84.77 96.97) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2256a5"
    },
    className: "cls-68",
    x: 105.62,
    y: 332.98,
    width: 358.46,
    height: 1.62,
    transform: "translate(-84.49 96.85) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2256a5"
    },
    className: "cls-68",
    x: 105.31,
    y: 331.95,
    width: 358.46,
    height: 1.62,
    transform: "translate(-84.22 96.73) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2256a5"
    },
    className: "cls-68",
    x: 104.99,
    y: 330.91,
    width: 358.46,
    height: 1.62,
    transform: "translate(-83.91 96.57) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2357a6"
    },
    className: "cls-237",
    x: 104.68,
    y: 329.88,
    width: 358.46,
    height: 1.62,
    transform: "translate(-83.74 96.6) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2157a6"
    },
    className: "cls-45",
    x: 104.37,
    y: 328.85,
    width: 358.46,
    height: 1.62,
    transform: "translate(-83.48 96.52) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2257a7"
    },
    className: "cls-103",
    x: 104.06,
    y: 327.82,
    width: 358.46,
    height: 1.62,
    transform: "translate(-83.03 96.13) rotate(-16.83)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2158a8"
    },
    className: "cls-26",
    x: 103.74,
    y: 326.79,
    width: 358.46,
    height: 1.62,
    transform: "translate(-82.77 96.03) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2158a8"
    },
    className: "cls-26",
    x: 103.43,
    y: 325.75,
    width: 358.46,
    height: 1.62,
    transform: "translate(-82.5 95.92) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2258a8"
    },
    className: "cls-188",
    x: 103.12,
    y: 324.72,
    width: 358.46,
    height: 1.62,
    transform: "translate(-82.24 95.81) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2159a8"
    },
    className: "cls-99",
    x: 102.81,
    y: 323.69,
    width: 358.46,
    height: 1.62,
    transform: "translate(-81.92 95.64) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2459a8"
    },
    className: "cls-86",
    x: 102.49,
    y: 322.66,
    width: 358.46,
    height: 1.62,
    transform: "translate(-81.65 95.52) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2459a8"
    },
    className: "cls-86",
    x: 102.18,
    y: 321.63,
    width: 358.46,
    height: 1.62,
    transform: "translate(-81.44 95.51) rotate(-16.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#225aa9"
    },
    className: "cls-10",
    x: 101.87,
    y: 320.59,
    width: 358.46,
    height: 1.62,
    transform: "translate(-81.12 95.33) rotate(-16.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#225aa9"
    },
    className: "cls-10",
    x: 101.56,
    y: 319.56,
    width: 358.46,
    height: 1.62,
    transform: "translate(-80.78 95.09) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#225aa9"
    },
    className: "cls-10",
    x: 101.24,
    y: 318.53,
    width: 358.46,
    height: 1.62,
    transform: "translate(-80.49 94.96) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#235baa"
    },
    className: "cls-186",
    x: 100.93,
    y: 317.5,
    width: 358.46,
    height: 1.62,
    transform: "translate(-80.24 94.87) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#235baa"
    },
    className: "cls-186",
    x: 100.62,
    y: 316.47,
    width: 358.46,
    height: 1.62,
    transform: "translate(-79.92 94.69) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#235baa"
    },
    className: "cls-186",
    x: 100.31,
    y: 315.43,
    width: 358.46,
    height: 1.62,
    transform: "translate(-79.67 94.6) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#255caa"
    },
    className: "cls-171",
    x: 99.99,
    y: 314.4,
    width: 358.46,
    height: 1.62,
    transform: "translate(-79.42 94.53) rotate(-16.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#235caa"
    },
    className: "cls-158",
    x: 99.68,
    y: 313.37,
    width: 358.46,
    height: 1.62,
    transform: "translate(-79.13 94.4) rotate(-16.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#255caa"
    },
    className: "cls-171",
    x: 99.37,
    y: 312.34,
    width: 358.46,
    height: 1.62,
    transform: "translate(-78.77 94.14) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#245dab"
    },
    className: "cls-34",
    x: 99.06,
    y: 311.31,
    width: 358.46,
    height: 1.62,
    transform: "translate(-78.5 94.03) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#245dab"
    },
    className: "cls-34",
    x: 98.74,
    y: 310.27,
    width: 358.46,
    height: 1.62,
    transform: "translate(-78.25 93.94) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#255dab"
    },
    className: "cls-116",
    x: 98.43,
    y: 309.24,
    width: 358.46,
    height: 1.62,
    transform: "translate(-77.92 93.74) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#255dab"
    },
    className: "cls-116",
    x: 98.12,
    y: 308.21,
    width: 358.46,
    height: 1.62,
    transform: "translate(-77.67 93.67) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#265eac"
    },
    className: "cls-72",
    x: 97.8,
    y: 307.18,
    width: 358.46,
    height: 1.62,
    transform: "translate(-77.42 93.59) rotate(-16.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#265eac"
    },
    className: "cls-72",
    x: 97.49,
    y: 306.15,
    width: 358.46,
    height: 1.62,
    transform: "translate(-77.12 93.44) rotate(-16.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#265eac"
    },
    className: "cls-72",
    x: 97.18,
    y: 305.11,
    width: 358.46,
    height: 1.62,
    transform: "translate(-76.78 93.21) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#245fac"
    },
    className: "cls-219",
    x: 96.87,
    y: 304.08,
    width: 358.46,
    height: 1.62,
    transform: "translate(-76.5 93.09) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#245fac"
    },
    className: "cls-219",
    x: 96.55,
    y: 303.05,
    width: 358.46,
    height: 1.62,
    transform: "translate(-76.24 92.98) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#265fac"
    },
    className: "cls-207",
    x: 96.24,
    y: 302.02,
    width: 358.46,
    height: 1.62,
    transform: "translate(-75.93 92.81) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2560ad"
    },
    className: "cls-176",
    x: 95.93,
    y: 300.99,
    width: 358.46,
    height: 1.62,
    transform: "translate(-75.66 92.71) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2560ad"
    },
    className: "cls-176",
    x: 95.62,
    y: 299.95,
    width: 358.46,
    height: 1.62,
    transform: "translate(-75.41 92.63) rotate(-16.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2760ad"
    },
    className: "cls-231",
    x: 95.3,
    y: 298.92,
    width: 358.46,
    height: 1.62,
    transform: "translate(-75.16 92.55) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2661ad"
    },
    className: "cls-184",
    x: 94.99,
    y: 297.89,
    width: 358.46,
    height: 1.62,
    transform: "translate(-74.78 92.27) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2661ad"
    },
    className: "cls-184",
    x: 94.68,
    y: 296.86,
    width: 358.46,
    height: 1.62,
    transform: "translate(-74.5 92.13) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2661ad"
    },
    className: "cls-184",
    x: 94.37,
    y: 295.83,
    width: 358.46,
    height: 1.62,
    transform: "translate(-74.22 92.01) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2562ae"
    },
    className: "cls-185",
    x: 94.05,
    y: 294.8,
    width: 358.46,
    height: 1.62,
    transform: "translate(-73.93 91.86) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2662ae"
    },
    className: "cls-54",
    x: 93.74,
    y: 293.76,
    width: 358.46,
    height: 1.62,
    transform: "translate(-73.66 91.77) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2662ae"
    },
    className: "cls-54",
    x: 93.43,
    y: 292.73,
    width: 358.46,
    height: 1.62,
    transform: "translate(-73.42 91.7) rotate(-16.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2763af"
    },
    className: "cls-96",
    x: 93.12,
    y: 291.7,
    width: 358.46,
    height: 1.62,
    transform: "translate(-73.15 91.59) rotate(-16.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2763af"
    },
    className: "cls-96",
    x: 92.8,
    y: 290.67,
    width: 358.46,
    height: 1.62,
    transform: "translate(-72.78 91.31) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2763af"
    },
    className: "cls-96",
    x: 92.49,
    y: 289.64,
    width: 358.46,
    height: 1.62,
    transform: "translate(-72.53 91.24) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2764af"
    },
    className: "cls-180",
    x: 92.18,
    y: 288.6,
    width: 358.46,
    height: 1.62,
    transform: "translate(-72.21 91.05) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2764af"
    },
    className: "cls-180",
    x: 91.87,
    y: 287.57,
    width: 358.46,
    height: 1.62,
    transform: "translate(-71.92 90.91) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2764af"
    },
    className: "cls-180",
    x: 91.55,
    y: 286.54,
    width: 358.46,
    height: 1.62,
    transform: "translate(-71.65 90.8) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2865b0"
    },
    className: "cls-17",
    x: 91.24,
    y: 285.51,
    width: 358.46,
    height: 1.62,
    transform: "translate(-71.41 90.74) rotate(-16.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2865b0"
    },
    className: "cls-17",
    x: 90.93,
    y: 284.48,
    width: 358.46,
    height: 1.62,
    transform: "translate(-71.15 90.66) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2865b0"
    },
    className: "cls-17",
    x: 90.62,
    y: 283.44,
    width: 358.46,
    height: 1.62,
    transform: "translate(-70.79 90.39) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2666b1"
    },
    className: "cls-220",
    x: 90.3,
    y: 282.41,
    width: 358.46,
    height: 1.62,
    transform: "translate(-70.52 90.29) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2866b1"
    },
    className: "cls-16",
    x: 89.99,
    y: 281.38,
    width: 358.46,
    height: 1.62,
    transform: "translate(-70.21 90.11) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2866b1"
    },
    className: "cls-16",
    x: 89.68,
    y: 280.35,
    width: 358.46,
    height: 1.62,
    transform: "translate(-69.96 90.03) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2866b1"
    },
    className: "cls-16",
    x: 89.37,
    y: 279.32,
    width: 358.46,
    height: 1.62,
    transform: "translate(-69.64 89.84) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2a66b1"
    },
    className: "cls-82",
    x: 89.05,
    y: 278.28,
    width: 358.46,
    height: 1.62,
    transform: "translate(-69.41 89.79) rotate(-16.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2a66b1"
    },
    className: "cls-82",
    x: 88.74,
    y: 277.25,
    width: 358.46,
    height: 1.62,
    transform: "translate(-69.13 89.68) rotate(-16.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2a66b1"
    },
    className: "cls-82",
    x: 88.43,
    y: 276.22,
    width: 358.46,
    height: 1.62,
    transform: "translate(-68.79 89.43) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2867b2"
    },
    className: "cls-63",
    x: 88.12,
    y: 275.19,
    width: 358.46,
    height: 1.62,
    transform: "translate(-68.52 89.34) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2867b2"
    },
    className: "cls-63",
    x: 87.8,
    y: 274.16,
    width: 358.46,
    height: 1.62,
    transform: "translate(-68.22 89.18) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2a67b2"
    },
    className: "cls-174",
    x: 87.49,
    y: 273.12,
    width: 358.46,
    height: 1.62,
    transform: "translate(-67.95 89.07) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2968b2"
    },
    className: "cls-210",
    x: 87.18,
    y: 272.09,
    width: 358.46,
    height: 1.62,
    transform: "translate(-67.63 88.86) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2b68b2"
    },
    className: "cls-137",
    x: 86.87,
    y: 271.06,
    width: 358.46,
    height: 1.62,
    transform: "translate(-67.41 88.86) rotate(-16.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2b68b2"
    },
    className: "cls-137",
    x: 86.55,
    y: 270.03,
    width: 358.46,
    height: 1.62,
    transform: "translate(-67.15 88.77) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2969b3"
    },
    className: "cls-109",
    x: 86.24,
    y: 269,
    width: 358.46,
    height: 1.62,
    transform: "translate(-66.79 88.5) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2c69b3"
    },
    className: "cls-121",
    x: 85.93,
    y: 267.96,
    width: 358.46,
    height: 1.62,
    transform: "translate(-66.53 88.41) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2a69b3"
    },
    className: "cls-51",
    x: 85.62,
    y: 266.93,
    width: 358.46,
    height: 1.62,
    transform: "translate(-66.21 88.22) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2b6ab3"
    },
    className: "cls-160",
    x: 85.3,
    y: 265.9,
    width: 358.46,
    height: 1.62,
    transform: "translate(-65.95 88.13) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2b6ab3"
    },
    className: "cls-160",
    x: 84.99,
    y: 264.87,
    width: 358.46,
    height: 1.62,
    transform: "translate(-65.63 87.92) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2b6ab3"
    },
    className: "cls-160",
    x: 84.68,
    y: 263.84,
    width: 358.46,
    height: 1.62,
    transform: "translate(-65.43 87.94) rotate(-16.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2b6bb4"
    },
    className: "cls-73",
    x: 84.37,
    y: 262.8,
    width: 358.46,
    height: 1.62,
    transform: "translate(-65.15 87.83) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2b6bb4"
    },
    className: "cls-73",
    x: 84.05,
    y: 261.77,
    width: 358.46,
    height: 1.62,
    transform: "translate(-64.79 87.56) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2b6bb4"
    },
    className: "cls-73",
    x: 83.74,
    y: 260.74,
    width: 358.46,
    height: 1.62,
    transform: "translate(-64.5 87.41) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2c6cb5"
    },
    className: "cls-53",
    x: 83.43,
    y: 259.71,
    width: 358.46,
    height: 1.62,
    transform: "translate(-64.22 87.29) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2c6cb5"
    },
    className: "cls-53",
    x: 83.11,
    y: 258.68,
    width: 358.46,
    height: 1.62,
    transform: "translate(-63.96 87.2) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2c6cb5"
    },
    className: "cls-53",
    x: 82.8,
    y: 257.64,
    width: 358.46,
    height: 1.62,
    transform: "translate(-63.62 86.96) rotate(-16.83)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2d6cb5"
    },
    className: "cls-74",
    x: 82.49,
    y: 256.61,
    width: 358.46,
    height: 1.62,
    transform: "translate(-63.43 87.01) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2d6cb5"
    },
    className: "cls-74",
    x: 82.18,
    y: 255.58,
    width: 358.46,
    height: 1.62,
    transform: "translate(-63.15 86.89) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2d6cb5"
    },
    className: "cls-74",
    x: 81.87,
    y: 254.55,
    width: 358.46,
    height: 1.62,
    transform: "translate(-62.81 86.64) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2c6db6"
    },
    className: "cls-58",
    x: 81.55,
    y: 253.52,
    width: 358.46,
    height: 1.62,
    transform: "translate(-62.51 86.48) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2e6db6"
    },
    className: "cls-169",
    x: 81.24,
    y: 252.49,
    width: 358.46,
    height: 1.62,
    transform: "translate(-62.22 86.35) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2e6db6"
    },
    className: "cls-169",
    x: 80.93,
    y: 251.45,
    width: 358.46,
    height: 1.62,
    transform: "translate(-61.91 86.16) rotate(-16.83)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2e6db6"
    },
    className: "cls-169",
    x: 80.61,
    y: 250.42,
    width: 358.46,
    height: 1.62,
    transform: "translate(-61.63 86.03) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2e6eb7"
    },
    className: "cls-161",
    x: 80.3,
    y: 249.39,
    width: 358.46,
    height: 1.62,
    transform: "translate(-61.44 86.09) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2e6eb7"
    },
    className: "cls-161",
    x: 79.99,
    y: 248.36,
    width: 358.46,
    height: 1.62,
    transform: "translate(-61.14 85.93) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2f6eb6"
    },
    className: "cls-105",
    x: 79.68,
    y: 247.33,
    width: 358.46,
    height: 1.62,
    transform: "translate(-60.88 85.84) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2e6fb7"
    },
    className: "cls-56",
    x: 79.36,
    y: 246.29,
    width: 358.46,
    height: 1.62,
    transform: "translate(-60.51 85.54) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2f6fb7"
    },
    className: "cls-146",
    x: 79.05,
    y: 245.26,
    width: 358.46,
    height: 1.62,
    transform: "translate(-60.24 85.43) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2f6fb7"
    },
    className: "cls-146",
    x: 78.74,
    y: 244.23,
    width: 358.46,
    height: 1.62,
    transform: "translate(-59.92 85.22) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2e70b8"
    },
    className: "cls-102",
    x: 78.43,
    y: 243.2,
    width: 358.46,
    height: 1.62,
    transform: "translate(-59.63 85.09) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2e70b8"
    },
    className: "cls-102",
    x: 78.11,
    y: 242.17,
    width: 358.46,
    height: 1.62,
    transform: "translate(-59.36 84.97) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2e70b8"
    },
    className: "cls-102",
    x: 77.8,
    y: 241.13,
    width: 358.46,
    height: 1.62,
    transform: "translate(-59.15 85) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2f71b8"
    },
    className: "cls-117",
    x: 77.49,
    y: 240.1,
    width: 358.46,
    height: 1.62,
    transform: "translate(-58.87 84.88) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2f71b8"
    },
    className: "cls-117",
    x: 77.18,
    y: 239.07,
    width: 358.46,
    height: 1.62,
    transform: "translate(-58.5 84.58) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2f71b8"
    },
    className: "cls-117",
    x: 76.86,
    y: 238.04,
    width: 358.46,
    height: 1.62,
    transform: "translate(-58.24 84.5) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3072b9"
    },
    className: "cls-23",
    x: 76.55,
    y: 237.01,
    width: 358.46,
    height: 1.62,
    transform: "translate(-57.91 84.27) rotate(-16.83)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3072b9"
    },
    className: "cls-23",
    x: 76.24,
    y: 235.97,
    width: 358.46,
    height: 1.62,
    transform: "translate(-57.65 84.18) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3072b9"
    },
    className: "cls-23",
    x: 75.93,
    y: 234.94,
    width: 358.46,
    height: 1.62,
    transform: "translate(-57.36 84.04) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3073ba"
    },
    className: "cls-187",
    x: 75.61,
    y: 233.91,
    width: 358.46,
    height: 1.62,
    transform: "translate(-57.14 84.04) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3073ba"
    },
    className: "cls-187",
    x: 75.3,
    y: 232.88,
    width: 358.46,
    height: 1.62,
    transform: "translate(-56.87 83.93) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3172b9"
    },
    className: "cls-64",
    x: 74.99,
    y: 231.85,
    width: 358.46,
    height: 1.62,
    transform: "translate(-56.51 83.65) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3173ba"
    },
    className: "cls-236",
    x: 74.68,
    y: 230.81,
    width: 358.46,
    height: 1.62,
    transform: "translate(-56.21 83.49) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3173ba"
    },
    className: "cls-236",
    x: 74.36,
    y: 229.78,
    width: 358.46,
    height: 1.62,
    transform: "translate(-55.92 83.34) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3173ba"
    },
    className: "cls-236",
    x: 74.05,
    y: 228.75,
    width: 358.46,
    height: 1.62,
    transform: "translate(-55.67 83.28) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3174ba"
    },
    className: "cls-84",
    x: 73.74,
    y: 227.72,
    width: 358.46,
    height: 1.62,
    transform: "translate(-55.36 83.09) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3374ba"
    },
    className: "cls-170",
    x: 73.43,
    y: 226.69,
    width: 358.46,
    height: 1.62,
    transform: "translate(-55.14 83.09) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3374ba"
    },
    className: "cls-170",
    x: 73.11,
    y: 225.65,
    width: 358.46,
    height: 1.62,
    transform: "translate(-54.85 82.96) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3175bb"
    },
    className: "cls-39",
    x: 72.8,
    y: 224.62,
    width: 358.46,
    height: 1.62,
    transform: "translate(-54.51 82.69) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3175bb"
    },
    className: "cls-39",
    x: 72.49,
    y: 223.59,
    width: 358.46,
    height: 1.62,
    transform: "translate(-54.21 82.54) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3175bb"
    },
    className: "cls-39",
    x: 72.18,
    y: 222.56,
    width: 358.46,
    height: 1.62,
    transform: "translate(-53.92 82.39) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3375bb"
    },
    className: "cls-191",
    x: 71.86,
    y: 221.53,
    width: 358.46,
    height: 1.62,
    transform: "translate(-53.67 82.33) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3375bb"
    },
    className: "cls-191",
    x: 71.55,
    y: 220.49,
    width: 358.46,
    height: 1.62,
    transform: "translate(-53.37 82.16) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3375bb"
    },
    className: "cls-191",
    x: 71.24,
    y: 219.46,
    width: 358.46,
    height: 1.62,
    transform: "translate(-53.16 82.2) rotate(-16.88)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3375bb"
    },
    className: "cls-191",
    x: 70.93,
    y: 218.43,
    width: 358.46,
    height: 1.62,
    transform: "translate(-52.85 82) rotate(-16.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3377bc"
    },
    className: "cls-21",
    x: 70.61,
    y: 217.4,
    width: 358.46,
    height: 1.62,
    transform: "translate(-52.49 81.72) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3377bc"
    },
    className: "cls-21",
    x: 70.3,
    y: 216.37,
    width: 358.46,
    height: 1.62,
    transform: "translate(-52.2 81.58) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3377bc"
    },
    className: "cls-21",
    x: 69.99,
    y: 215.33,
    width: 358.46,
    height: 1.62,
    transform: "translate(-51.94 81.48) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3477bc"
    },
    className: "cls-57",
    x: 69.68,
    y: 214.3,
    width: 358.46,
    height: 1.62,
    transform: "translate(-51.67 81.39) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3477bc"
    },
    className: "cls-57",
    x: 69.36,
    y: 213.27,
    width: 358.46,
    height: 1.62,
    transform: "translate(-51.37 81.21) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3477bc"
    },
    className: "cls-57",
    x: 69.05,
    y: 212.24,
    width: 358.46,
    height: 1.62,
    transform: "translate(-51.15 81.24) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3478bd"
    },
    className: "cls-214",
    x: 68.74,
    y: 211.21,
    width: 358.46,
    height: 1.62,
    transform: "translate(-50.85 81.07) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3478bd"
    },
    className: "cls-214",
    x: 68.43,
    y: 210.18,
    width: 358.46,
    height: 1.62,
    transform: "translate(-50.51 80.8) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3578bd"
    },
    className: "cls-91",
    x: 68.11,
    y: 209.14,
    width: 358.46,
    height: 1.62,
    transform: "translate(-50.2 80.62) rotate(-16.83)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3479be"
    },
    className: "cls-27",
    x: 67.8,
    y: 208.11,
    width: 358.46,
    height: 1.62,
    transform: "translate(-49.94 80.55) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3479be"
    },
    className: "cls-27",
    x: 67.49,
    y: 207.08,
    width: 358.46,
    height: 1.62,
    transform: "translate(-49.67 80.45) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3479be"
    },
    className: "cls-27",
    x: 67.17,
    y: 206.05,
    width: 358.46,
    height: 1.62,
    transform: "translate(-49.36 80.26) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3579be"
    },
    className: "cls-100",
    x: 66.86,
    y: 205.02,
    width: 358.46,
    height: 1.62,
    transform: "translate(-49.15 80.3) rotate(-16.88)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3579be"
    },
    className: "cls-100",
    x: 66.55,
    y: 203.98,
    width: 358.46,
    height: 1.62,
    transform: "translate(-48.85 80.12) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3579be"
    },
    className: "cls-100",
    x: 66.24,
    y: 202.95,
    width: 358.46,
    height: 1.62,
    transform: "translate(-48.51 79.86) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#347abf"
    },
    className: "cls-14",
    x: 65.92,
    y: 201.92,
    width: 358.46,
    height: 1.62,
    transform: "translate(-48.21 79.69) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#367bbf"
    },
    className: "cls-164",
    x: 65.61,
    y: 200.89,
    width: 358.46,
    height: 1.62,
    transform: "translate(-47.94 79.6) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#367bbf"
    },
    className: "cls-164",
    x: 65.3,
    y: 199.86,
    width: 358.46,
    height: 1.62,
    transform: "translate(-47.65 79.46) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#357bbf"
    },
    className: "cls-50",
    x: 64.99,
    y: 198.82,
    width: 358.46,
    height: 1.62,
    transform: "translate(-47.37 79.33) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#357bbf"
    },
    className: "cls-50",
    x: 64.67,
    y: 197.79,
    width: 358.46,
    height: 1.62,
    transform: "translate(-47.14 79.34) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#357bbf"
    },
    className: "cls-50",
    x: 64.36,
    y: 196.76,
    width: 358.46,
    height: 1.62,
    transform: "translate(-46.83 79.13) rotate(-16.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#367cc0"
    },
    className: "cls-9",
    x: 64.05,
    y: 195.73,
    width: 358.46,
    height: 1.62,
    transform: "translate(-46.51 78.93) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#367cc0"
    },
    className: "cls-9",
    x: 63.74,
    y: 194.7,
    width: 358.46,
    height: 1.62,
    transform: "translate(-46.22 78.78) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#367cc0"
    },
    className: "cls-9",
    x: 63.42,
    y: 193.66,
    width: 358.46,
    height: 1.62,
    transform: "translate(-45.95 78.68) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#367cc0"
    },
    className: "cls-9",
    x: 63.11,
    y: 192.63,
    width: 358.46,
    height: 1.62,
    transform: "translate(-45.66 78.52) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#377dc0"
    },
    className: "cls-6",
    x: 62.8,
    y: 191.6,
    width: 358.46,
    height: 1.62,
    transform: "translate(-45.37 78.39) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#377cc0"
    },
    className: "cls-213",
    x: 62.49,
    y: 190.57,
    width: 358.46,
    height: 1.62,
    transform: "translate(-45.13 78.36) rotate(-16.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#377cc0"
    },
    className: "cls-213",
    x: 62.17,
    y: 189.54,
    width: 358.46,
    height: 1.62,
    transform: "translate(-44.83 78.2) rotate(-16.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#387dc1"
    },
    className: "cls-205",
    x: 61.86,
    y: 188.5,
    width: 358.46,
    height: 1.62,
    transform: "translate(-44.51 77.97) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#387dc1"
    },
    className: "cls-205",
    x: 61.55,
    y: 187.47,
    width: 358.46,
    height: 1.62,
    transform: "translate(-44.22 77.84) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#387dc1"
    },
    className: "cls-205",
    x: 61.24,
    y: 186.44,
    width: 358.46,
    height: 1.62,
    transform: "translate(-43.96 77.75) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#377ec1"
    },
    className: "cls-87",
    x: 60.92,
    y: 185.41,
    width: 358.46,
    height: 1.62,
    transform: "translate(-43.65 77.57) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#377ec1"
    },
    className: "cls-87",
    x: 60.61,
    y: 184.38,
    width: 358.46,
    height: 1.62,
    transform: "translate(-43.38 77.47) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#397ec1"
    },
    className: "cls-15",
    x: 60.3,
    y: 183.34,
    width: 358.46,
    height: 1.62,
    transform: "translate(-43.13 77.42) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#387fc2"
    },
    className: "cls-224",
    x: 59.99,
    y: 182.31,
    width: 358.46,
    height: 1.62,
    transform: "translate(-42.82 77.24) rotate(-16.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#387fc2"
    },
    className: "cls-224",
    x: 59.67,
    y: 181.28,
    width: 358.46,
    height: 1.62,
    transform: "translate(-42.52 77.04) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#397fc2"
    },
    className: "cls-122",
    x: 59.36,
    y: 180.25,
    width: 358.46,
    height: 1.62,
    transform: "translate(-42.23 76.91) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3980c2"
    },
    className: "cls-70",
    x: 59.05,
    y: 179.22,
    width: 358.46,
    height: 1.62,
    transform: "translate(-41.95 76.79) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3980c2"
    },
    className: "cls-70",
    x: 58.74,
    y: 178.18,
    width: 358.46,
    height: 1.62,
    transform: "translate(-41.66 76.64) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3980c2"
    },
    className: "cls-70",
    x: 58.42,
    y: 177.15,
    width: 358.46,
    height: 1.62,
    transform: "translate(-41.39 76.54) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3a80c3"
    },
    className: "cls-79",
    x: 58.11,
    y: 176.12,
    width: 358.46,
    height: 1.62,
    transform: "translate(-41.11 76.43) rotate(-16.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3a80c3"
    },
    className: "cls-79",
    x: 57.8,
    y: 175.09,
    width: 358.46,
    height: 1.62,
    transform: "translate(-40.84 76.33) rotate(-16.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3a80c3"
    },
    className: "cls-79",
    x: 57.49,
    y: 174.06,
    width: 358.46,
    height: 1.62,
    transform: "translate(-40.54 76.18) rotate(-16.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3b81c3"
    },
    className: "cls-35",
    x: 57.17,
    y: 173.02,
    width: 358.46,
    height: 1.62,
    transform: "translate(-40.23 75.95) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3b81c3"
    },
    className: "cls-35",
    x: 56.86,
    y: 171.99,
    width: 358.46,
    height: 1.62,
    transform: "translate(-39.95 75.85) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3b81c3"
    },
    className: "cls-35",
    x: 56.55,
    y: 170.96,
    width: 358.46,
    height: 1.62,
    transform: "translate(-39.66 75.69) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3a82c4"
    },
    className: "cls-7",
    x: 56.24,
    y: 169.93,
    width: 358.46,
    height: 1.62,
    transform: "translate(-39.38 75.58) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3a82c4"
    },
    className: "cls-7",
    x: 55.92,
    y: 168.9,
    width: 358.46,
    height: 1.62,
    transform: "translate(-39.09 75.42) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3c82c4"
    },
    className: "cls-175",
    x: 55.61,
    y: 167.87,
    width: 358.46,
    height: 1.62,
    transform: "translate(-38.84 75.4) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3b83c4"
    },
    className: "cls-143",
    x: 55.3,
    y: 166.83,
    width: 358.46,
    height: 1.62,
    transform: "translate(-38.54 75.22) rotate(-16.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3b83c4"
    },
    className: "cls-143",
    x: 54.99,
    y: 165.8,
    width: 358.46,
    height: 1.62,
    transform: "translate(-38.23 75.02) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3c82c4"
    },
    className: "cls-175",
    x: 54.67,
    y: 164.77,
    width: 358.46,
    height: 1.62,
    transform: "translate(-37.94 74.88) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3c82c4"
    },
    className: "cls-175",
    x: 54.36,
    y: 163.74,
    width: 358.46,
    height: 1.62,
    transform: "translate(-37.66 74.74) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3c83c5"
    },
    className: "cls-134",
    x: 54.05,
    y: 162.71,
    width: 358.46,
    height: 1.62,
    transform: "translate(-37.39 74.65) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3c83c5"
    },
    className: "cls-134",
    x: 53.73,
    y: 161.67,
    width: 358.46,
    height: 1.62,
    transform: "translate(-37.09 74.48) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3c83c5"
    },
    className: "cls-134",
    x: 53.42,
    y: 160.64,
    width: 358.46,
    height: 1.62,
    transform: "translate(-36.83 74.44) rotate(-16.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3d84c5"
    },
    className: "cls-115",
    x: 53.11,
    y: 159.61,
    width: 358.46,
    height: 1.62,
    transform: "translate(-36.54 74.29) rotate(-16.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3d84c5"
    },
    className: "cls-115",
    x: 52.8,
    y: 158.58,
    width: 358.46,
    height: 1.62,
    transform: "translate(-36.24 74.1) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3d84c5"
    },
    className: "cls-115",
    x: 52.48,
    y: 157.55,
    width: 358.46,
    height: 1.62,
    transform: "translate(-35.94 73.93) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3d85c6"
    },
    className: "cls-32",
    x: 52.17,
    y: 156.51,
    width: 358.46,
    height: 1.62,
    transform: "translate(-35.66 73.8) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3d85c6"
    },
    className: "cls-32",
    x: 51.86,
    y: 155.48,
    width: 358.46,
    height: 1.62,
    transform: "translate(-35.37 73.66) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3e85c6"
    },
    className: "cls-157",
    x: 51.55,
    y: 154.45,
    width: 358.46,
    height: 1.62,
    transform: "translate(-35.07 73.49) rotate(-16.83)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3d86c6"
    },
    className: "cls-125",
    x: 51.23,
    y: 153.42,
    width: 358.46,
    height: 1.62,
    transform: "translate(-34.83 73.5) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3f85c6"
    },
    className: "cls-95",
    x: 50.92,
    y: 152.39,
    width: 358.46,
    height: 1.62,
    transform: "translate(-34.55 73.38) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3f85c6"
    },
    className: "cls-95",
    x: 50.61,
    y: 151.35,
    width: 358.46,
    height: 1.62,
    transform: "translate(-34.24 73.15) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3e87c7"
    },
    className: "cls-36",
    x: 50.3,
    y: 150.32,
    width: 358.46,
    height: 1.62,
    transform: "translate(-33.95 73) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#4087c7"
    },
    className: "cls-129",
    x: 49.98,
    y: 149.29,
    width: 358.46,
    height: 1.62,
    transform: "translate(-33.67 72.88) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#4087c7"
    },
    className: "cls-129",
    x: 49.67,
    y: 148.26,
    width: 358.46,
    height: 1.62,
    transform: "translate(-33.37 72.72) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#4088c8"
    },
    className: "cls-112",
    x: 49.36,
    y: 147.23,
    width: 358.46,
    height: 1.62,
    transform: "translate(-33.08 72.56) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#4088c8"
    },
    className: "cls-112",
    x: 49.05,
    y: 146.19,
    width: 358.46,
    height: 1.62,
    transform: "translate(-32.82 72.51) rotate(-16.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#4088c8"
    },
    className: "cls-112",
    x: 48.73,
    y: 145.16,
    width: 358.46,
    height: 1.62,
    transform: "translate(-32.55 72.42) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#4188c8"
    },
    className: "cls-166",
    x: 48.42,
    y: 144.13,
    width: 358.46,
    height: 1.62,
    transform: "translate(-32.24 72.22) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#4188c8"
    },
    className: "cls-166",
    x: 48.11,
    y: 143.1,
    width: 358.46,
    height: 1.62,
    transform: "translate(-31.94 72.04) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#4188c8"
    },
    className: "cls-166",
    x: 47.8,
    y: 142.07,
    width: 358.46,
    height: 1.62,
    transform: "translate(-31.67 71.94) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#4289c9"
    },
    className: "cls-85",
    x: 47.48,
    y: 141.03,
    width: 358.46,
    height: 1.62,
    transform: "translate(-31.38 71.78) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#4289c9"
    },
    className: "cls-85",
    x: 47.17,
    y: 140,
    width: 358.46,
    height: 1.62,
    transform: "translate(-31.09 71.63) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#4289c9"
    },
    className: "cls-85",
    x: 46.86,
    y: 138.97,
    width: 358.46,
    height: 1.62,
    transform: "translate(-30.83 71.61) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#438ac9"
    },
    className: "cls-33",
    x: 46.55,
    y: 137.94,
    width: 358.46,
    height: 1.62,
    transform: "translate(-30.55 71.49) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#438ac9"
    },
    className: "cls-33",
    x: 46.23,
    y: 136.91,
    width: 358.46,
    height: 1.62,
    transform: "translate(-30.24 71.26) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#438ac9"
    },
    className: "cls-33",
    x: 45.92,
    y: 135.87,
    width: 358.46,
    height: 1.62,
    transform: "translate(-29.94 71.1) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#438ac9"
    },
    className: "cls-33",
    x: 45.61,
    y: 134.84,
    width: 358.46,
    height: 1.62,
    transform: "translate(-29.67 71) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#448bca"
    },
    className: "cls-154",
    x: 45.3,
    y: 133.81,
    width: 358.46,
    height: 1.62,
    transform: "translate(-29.37 70.79) rotate(-16.83)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#448bca"
    },
    className: "cls-154",
    x: 44.98,
    y: 132.78,
    width: 358.46,
    height: 1.62,
    transform: "translate(-29.09 70.69) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#448ac9"
    },
    className: "cls-98",
    x: 44.67,
    y: 131.75,
    width: 358.46,
    height: 1.62,
    transform: "translate(-28.83 70.67) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#458cca"
    },
    className: "cls-41",
    x: 44.36,
    y: 130.71,
    width: 358.46,
    height: 1.62,
    transform: "translate(-28.54 70.53) rotate(-16.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#458cca"
    },
    className: "cls-41",
    x: 44.05,
    y: 129.68,
    width: 358.46,
    height: 1.62,
    transform: "translate(-28.23 70.3) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#458cca"
    },
    className: "cls-41",
    x: 43.73,
    y: 128.65,
    width: 358.46,
    height: 1.62,
    transform: "translate(-27.95 70.16) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#458dcb"
    },
    className: "cls-29",
    x: 43.42,
    y: 127.62,
    width: 358.46,
    height: 1.62,
    transform: "translate(-27.67 70.05) rotate(-16.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#468ccb"
    },
    className: "cls-136",
    x: 43.11,
    y: 126.59,
    width: 358.46,
    height: 1.62,
    transform: "translate(-27.37 69.86) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#468ccb"
    },
    className: "cls-136",
    x: 42.8,
    y: 125.56,
    width: 358.46,
    height: 1.62,
    transform: "translate(-27.09 69.76) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#468ecc"
    },
    className: "cls-209",
    x: 42.48,
    y: 124.52,
    width: 358.46,
    height: 1.62,
    transform: "translate(-26.83 69.71) rotate(-16.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#478dcb"
    },
    className: "cls-62",
    x: 42.17,
    y: 123.49,
    width: 358.46,
    height: 1.62,
    transform: "translate(-26.55 69.63) rotate(-16.88)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#478dcb"
    },
    className: "cls-62",
    x: 41.86,
    y: 122.46,
    width: 358.46,
    height: 1.62,
    transform: "translate(-26.23 69.35) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#478ecc"
    },
    className: "cls-216",
    x: 41.55,
    y: 121.43,
    width: 358.46,
    height: 1.62,
    transform: "translate(-25.95 69.21) rotate(-16.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#478ecc"
    },
    className: "cls-216",
    x: 20.28,
    y: -21.04,
    width: 358.46,
    height: 146.15,
    transform: "translate(-6.52 60.07) rotate(-16.85)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M173.49,491.85l-5.27,6.08c-4.05-3.32-7.95-4.78-12.57-4.78-5.03,0-8.67,2.27-8.67,6.65,0,4.05,2.19,5.84,11.51,8.76,9.81,3.08,16.62,7.13,16.62,17.67s-7.86,17.19-21.24,17.19c-8.92,0-15.57-3.16-20.19-7.7l5.51-6.16c4.13,3.49,8.59,5.59,14.43,5.59s10.3-2.92,10.3-8.35c0-4.7-2.35-6.81-11.11-9.49-11.75-3.65-16.86-8.35-16.86-16.86,0-9.32,8.03-15.48,19.05-15.48,8.19,0,13.62,2.43,18.48,6.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M204.14,542.35c-3.24,10.05-9.57,16.54-22.29,17.51l-1.05-7.54c8.51-1.3,11.27-4.05,13.7-10.13h-3.57l-13.62-42.89h11.03l9.32,36,9.73-36h10.7l-13.94,43.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M259.27,511.14v31.05h-10.38v-29.43c0-5.35-2.03-6.89-5.27-6.89-3.73,0-6.49,2.51-9,6.49v29.83h-10.38v-42.89h9l.81,5.59c3.32-4.3,7.62-6.81,13.05-6.81,7.7,0,12.16,4.86,12.16,13.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M302.32,503.12l-4.62,6.24c-2.84-2.11-5.43-3.08-8.67-3.08-6,0-9.65,4.38-9.65,14.67s3.81,14.03,9.65,14.03c3.24,0,5.51-1.05,8.67-3.08l4.62,6.57c-3.89,3.16-8.35,4.95-13.86,4.95-12.4,0-20.11-8.59-20.11-22.29s7.7-23.02,20.02-23.02c5.59,0,9.89,1.54,13.94,5.03Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M61.91,399.09c0,10.14-6.48,16.93-17.46,19.9,11.11,1.11,20.37,7.29,20.37,20.52,0,13.97-12.04,25.71-34.13,25.71-13.49,0-23.68-4.7-30.69-12.61l11.25-10.26c5.95,5.56,11.25,8.03,18.26,8.03,8.2,0,13.89-4.45,13.89-12.11,0-8.78-5.16-11.99-14.55-11.99h-7.41l2.25-13.47h5.16c7.94,0,12.83-3.96,12.83-10.88,0-6.06-4.63-9.64-11.91-9.64-6.62,0-12.17,2.47-17.46,7.29l-10.32-10.51c8.33-7.42,18.26-11.25,30.16-11.25,19.31,0,29.77,9.52,29.77,21.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M140.63,434.57c0,17.06-12.44,30.66-32.41,30.66-23.68,0-33.87-16.32-33.87-40.3,0-28.31,14.68-47.1,38.89-47.1,8.47,0,15.21,2.35,20.37,5.56l-7.67,11.62c-3.71-1.98-7.54-3.21-12.17-3.21-10.05,0-16.54,8.16-17.73,22.75,5.56-5.32,12.17-7.66,18.92-7.66,14.68,0,25.67,10.01,25.67,27.69ZM119.73,434.82c0-10.75-3.71-14.46-10.58-14.46-4.76,0-9.26,2.35-13.1,6.55.26,17.43,3.44,24.35,12.44,24.35,7.54,0,11.25-6.55,11.25-16.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M216.43,421.47c0,27.94-11.77,43.76-33.74,43.76s-33.73-15.82-33.73-43.76,11.77-43.63,33.73-43.63,33.74,15.58,33.74,43.63ZM170.39,421.47c0,22.13,3.57,29.3,12.3,29.3s12.3-6.67,12.3-29.3-3.7-29.17-12.3-29.17-12.3,7.05-12.3,29.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M261.28,377.46h54.64l-2.25,14.46h-30.69v22.74h26.72v14.46h-26.72v33.99h-21.7v-85.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M344.1,374c0,6.3-5.03,11.12-12.44,11.12s-12.3-4.82-12.3-11.12,5.16-11.12,12.3-11.12,12.44,4.82,12.44,11.12ZM342.25,463.12h-20.9v-65.64h20.9v65.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M357.46,446.44v-75.03l20.9-2.1v76.39c0,2.72,1.19,4.08,3.71,4.08,1.32,0,2.51-.25,3.44-.62l3.97,13.84c-3.04,1.24-7.54,2.23-12.7,2.23-12.17,0-19.32-6.8-19.32-18.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M458.4,436.05h-43.39c1.32,11.74,7.28,14.96,15.88,14.96,5.69,0,10.72-1.85,16.8-5.81l8.6,10.88c-7.01,5.19-16.01,9.15-27.38,9.15-23.42,0-35.32-14.09-35.32-34.61s11.51-35.23,32.81-35.23c20.11,0,32.41,12.36,32.41,33.62,0,2.1-.13,5.07-.4,7.05ZM438.29,423.44c-.13-8.9-3.04-15.08-11.38-15.08-7.01,0-10.98,4.08-12.04,15.95h23.42v-.87Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg360FileSyncLogo);
export default __webpack_public_path__ + "static/media/360FileSyncLogo.bc22e584f8e51087e8dfdfc035a11395.svg";
export { ForwardRef as ReactComponent };